import { valid, coerce, gte } from 'semver';
import { createPermissionCheck } from 'common/utils/helpers';

const MIN_IBMS_VERSION = 'v7';

export function isDiagnosticPackagesSupported(device) {
  if (!device?.properties?.reported?.productType) {
    return false;
  }

  const deviceAPIVersion = valid(coerce(device?.properties?.reported?.ibmsApiVersion));

  if (!deviceAPIVersion) {
    return false;
  }

  return gte(deviceAPIVersion, valid(coerce(MIN_IBMS_VERSION)));
}

export const canViewDiagnosticPackages = createPermissionCheck([
  'log_search_diagpackage',
  'log_search_instance_diagpackage'
]);

export const canRetrieveDiagnosticPackages = createPermissionCheck(['log_run_diagpackage']);

export const canDownloadDiagnosticPackages = createPermissionCheck(['log_download_diagpackage']);
